"use client";
import styled, { keyframes } from "styled-components";
import {
  FlexRow,
  Fonts,
  StyledImage,
  focusShadow
} from "../styles/globalsStyles";
import { OutsideLink } from "./OutsideLink";

const NatisCopyright = () => {
  return (
    <FadeOutContainer>
      <FlexRow $justifyContent="center" $alignItems="center" $gap={"1rem"}>
        <StyledLogoImg
          src={"/assets/nati.jpeg"}
          onClick={() => {
            window.open("https://www.linkedin.com/in/netanel-halevi-webdev/");
          }}
        />
        <OutsideLink
          href="https://www.linkedin.com/in/netanel-halevi-webdev/"
          target="_blank"
        >
          <MadeBy>𝙼𝚊𝚍𝚎 𝙱𝚢 𝙽𝚎𝚝𝚊𝚗𝚎𝚕 𝙷𝚊𝚕𝚎𝚟𝚒</MadeBy>
        </OutsideLink>
      </FlexRow>
    </FadeOutContainer>
  );
};

const fadeOutAnimation = keyframes`
  0% {
    opacity: .3;
  }
  15%{
    opacity: 1;

  }
  100% {
    opacity: 0;
  }
`;

const FadeOutContainer = styled.div`
  animation: ${fadeOutAnimation} 5s ease-in-out forwards;
`;

const StyledLogoImg = styled(StyledImage)`
  ${focusShadow}
  border-radius: 50%;
  width: 60px;
  height: 60px;
  cursor: pointer;
  opacity: 0.9;
`;

const MadeBy = styled.span`
  ${Fonts.small}
`;

export default NatisCopyright;
